<template>
  <transition
    name="fade"
    @after-enter="$emit('transitionEnd')"
    @after-leave="$emit('transitionEnd')"
  >
    <div class="projects-list" v-if="visible">
      <grid-row>
        <div
          v-for="(item, i) in items"
          :key="i"
          class="projects-list__item"
        >
          <border-box>
            <grid-row class="projects-list__item-row">
              <div class="projects-list__item-inner">
                <project-box
                  :title="item.title"
                  :link="item.link"
                  :photo="item.photo"
                />
              </div>
            </grid-row>
          </border-box>
        </div>
        <div class="projects-list__item"><border-box/></div>
        <div class="projects-list__item"><border-box xs-hide/></div>
      </grid-row>
    </div>
  </transition>
</template>

<script>
import ProjectBox from '@/containers/Projects/ProjectBox'
import BorderBox from '@/components/BorderBox'

export default {
  components: {
    ProjectBox,
    BorderBox
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .projects-list {
    &__item {
      @include grid-column((xs: 12, md: 6));

      &-inner {
        @include grid-column((xs: 12));
      }

      @include media-up(lg) {
        &:nth-child(odd) {
          @include nested-column-width(4, 9, lg);
        }

        &:nth-child(even) {
          @include nested-column-width(5, 9, lg);
        }

        &:nth-child(even) &-inner {
          @include nested-column-width(4, 5, lg);
        }
      }

      &-row {
        height: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Projects/ProjectsList.vue